module.exports = (emailAddress) => (emailAddress ? emailAddress
  .substr(0, emailAddress.indexOf('@'))
  .replace(/\./g, ' ')
  .replace(/\b[a-z]/g, (letter) => letter.toUpperCase()) : '');
